module.exports = __webpack_public_path__ + "media/application/images/landing-mockup-1440-8f9c1aea25e88d9e0c5f2c624d9910ff.png";